module.exports = __webpack_public_path__ + "static/media/export.2a6438a6.svg";